import { useMemo } from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { setChartSettingsTableSettingsAction } from '../../../redux/slices/analyses';
import { useChartContext } from '../../Chart/ChartContext';
import { ColumnMapping } from '../../Chart/interfaces';

interface IProps {
  analysisId: string;
  defaultColumnMapping?: ColumnMapping;
}

const useTableColumnMapping = ({
  analysisId,
  defaultColumnMapping = [],
}: IProps) => {
  const dispatch = useAppDispatch();
  const {
    settings: { chartSettings },
  } = useChartContext();
  const { tableSettings } = chartSettings;
  const columnMapping = useMemo(() => {
    if (tableSettings.columnMapping) {
      return tableSettings.columnMapping;
    }

    return defaultColumnMapping;
  }, [tableSettings, defaultColumnMapping]);

  const updateTableStateMapping = (newMapping: ColumnMapping) => {
    dispatch(
      setChartSettingsTableSettingsAction({
        analysisId,
        tableSettings: {
          columnMapping: newMapping,
        },
      }),
    );
  };

  const updateColumnMapping = (
    sourceIndex: number,
    destinationIndex: number,
  ) => {
    const newMapping = [...columnMapping];
    const [movedItem] = newMapping.splice(sourceIndex, 1);
    newMapping.splice(destinationIndex, 0, movedItem);

    // Update table settings mapping with the new order
    updateTableStateMapping(newMapping);

    return newMapping;
  };

  return {
    columnMapping,
    updateColumnMapping,
  };
};

export default useTableColumnMapping;
